import Box from '~/common/components/Box';

import CalculationHistory from '../CalculationHistory/CalculationHistory';
import IncomeHeader from './index.js';

const defaultSx = {
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 100,
  background: 'white',
};

type IncomeHeaderWithCalculationHistoryProps = {
  showCalculationHistory?: boolean;
  sx?: any;
};

const IncomeHeaderWithCalculationHistory = ({
  showCalculationHistory,
  sx,
}: Readonly<IncomeHeaderWithCalculationHistoryProps>) => {
  return (
    <Box sx={{ ...defaultSx, ...sx }}>
      <IncomeHeader />
      {showCalculationHistory && (
        <CalculationHistory
          position="absolute"
          top="5rem"
          right={0}
          background={'white'}
          marginRight=".5rem"
        />
      )}
    </Box>
  );
};

export default IncomeHeaderWithCalculationHistory;
